<template>
  <vx-card
    class="mt-3 relative z-999 vs-con-loading__container"
    title="Busca de Usuarios"
    collapseAction
    collapsed
    id="busca-usuarios"
    subtitle="Abaixo ficam os usuários encontratos no sistema, você pode fazer uma busca e filtrar as informações que precisa."
  >
    <div class="vx-row">
      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Nome:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <vs-input v-uppercase @keyup.enter="buscar()" class="w-full" v-model="filtro.nome" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>CPF:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <cpf-input v-uppercase @keyup.enter="buscar()" class="w-full" v-model="filtro.cpf" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Tipo de Usuário:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <tipo-usuario-select v-model="select.tipoUsuario"></tipo-usuario-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col v-if="todasAsAssociacoes" vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Associação:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <associacao-select v-model="select.associacao" :clearable="true"></associacao-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col v-if="todasAsEntidades" vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Entidade:</span>
          </vs-col>
          <vs-col vs-w="12" class="vx-col">
            <entidade-select
              v-model="select.entidade"
              :clearable="true"
              :associacao="select.associacao"
            ></entidade-select>
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-w="12" class="vx-col">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-row">
            <vs-button
              color="#5abfa3"
              type="relief"
              size="small"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="buscar()"
              class="mr-3"
            >Buscar</vs-button>
            <vs-button
              v-if="possuiFiltros"
              color="#5abfa3"
              type="relief"
              size="small"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="limparFiltros()"
            >Limpar Filtros</vs-button>
          </vs-col>
        </div>
      </vs-col>
    </div>
  </vx-card>
</template>


<script>
import AssociacaoSelect from "@/components/select/AssociacaoSelect.vue";
import EntidadeSelect from "@/components/select/EntidadeSelect.vue";
import TipoUsuarioSelect from "@/components/select/TipoUsuarioSelect.vue";
import CpfInput from "@/components/inputs/CpfInput.vue";

export default {
  name: "busca-contratos",
  components: {
    AssociacaoSelect,
    EntidadeSelect,
    TipoUsuarioSelect,
    CpfInput
  },
  data() {
    return {
      filtro: {},
      select: {
        associacao: null,
        entidade: null,
        tipoUsuario: null
      }
    };
  },
  created() {
    this.setupFiltros({ ...this.$route.query });
  },
  watch: {
    $route(to) {
      this.setupFiltros({ ...to.query });
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#busca-usuarios",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#busca-usuarios > .con-vs-loading");
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isUsuariosLoading();
    },
    possuiFiltros() {
      return Object.values(this.$route.query).length > 0;
    }
  },
  methods: {
    setupFiltros(query) {
      this.filtro = query;

      if (this.$route.query.associacao) {
        this.select.associacao = this.$store.getters.getAssociacoes(
          this.$route.query.associacao
        );
      }
      if (this.$route.query.entidade) {
        this.select.entidade = this.$store.getters.getEntidades(
          this.$route.query.entidade
        );
      }
      if (this.$route.query.tipoUsuario) {
        this.select.tipoUsuario = this.$store.getters.getTiposUsuario(
          this.$route.query.tipoUsuario
        );
      }
    },
    buscar() {
      const selects = ["associacao", "entidade", "tipoUsuario"];
      selects.map(select => {
        if (this.select[select]) {
          this.filtro[select] = this.select[select].id;
        } else {
          delete this.filtro[select];
        }
      });

      delete this.filtro.page;

      this.$router.push({
        name: "usuarios",
        query: { ...this.filtro }
      });
    },
    limparFiltros() {
      this.$router.push({ name: "usuarios" });
      this.select = {};
    }
  }
};
</script>
